var merge = require('webpack-merge')
var prodEnv = require('./prod.env')

module.exports = merge(prodEnv, {
  NODE_ENV: '"development"',
  //API_ROOT: '"http://139.217.19.120:7002"',
  API_ROOT: '"http://medicine.wiseltd.net:8005"',
  //API_ROOT: '"http://medicine.wiseltd.net:8005/"'
})



//////////////////
// WEBPACK FOOTER
// ./config/dev.env.js
// module id = 324
// module chunks = 77